<template>
  <NavBar />
  <main class="tests-page">
    <div class="container tests-container">
      <header class="page-header">
        <router-link :to="{ name: 'Excercise' }" class="back-link"><i class="bi bi-arrow-left" aria-hidden="true"></i>Tüm egzersizler</router-link>
        <span class="eyebrow">PRATİK YAP, GELİŞİMİNİ GÖR</span>
        <h1>Testler</h1>
        <p>Seviyeni keşfet, dil bilgini ve kelime dağarcığını geliştir.</p>
      </header>
      <div class="tests-layout">
        <nav class="category-panel" aria-label="Test kategorileri">
          <h2>Kategoriler</h2>
          <button type="button" class="category-button" :class="{ active: selectedCategory === 1 }" :aria-current="selectedCategory === 1 ? 'true' : undefined" @click="GetCategory(1)"><i class="bi bi-bar-chart" aria-hidden="true"></i>Level Test</button>
          <div v-for="group in categoryGroups" :key="group.id" class="category-group">
            <button type="button" class="category-button" :class="{ 'group-selected': group.items.some(item => item.id === selectedCategory) }" :aria-expanded="group.visible" :aria-controls="group.id" @click="group.id === 'grammar-categories' ? GrammarToggle() : VocabularyToggle()">
              <i :class="group.icon" aria-hidden="true"></i><span>{{ group.title }}</span><i class="bi category-chevron" :class="group.visible ? 'bi-chevron-up' : 'bi-chevron-down'" aria-hidden="true"></i>
            </button>
            <ul :id="group.id" v-show="group.visible" class="subcategory-list">
              <li v-for="category in group.items" :key="category.id"><button type="button" :class="{ active: selectedCategory === category.id }" :aria-current="selectedCategory === category.id ? 'true' : undefined" @click="GetCategory(category.id)">{{ category.label }}</button></li>
            </ul>
          </div>
          <p class="category-note">Bir kategori seç, kendi hızında pratik yap.</p>
        </nav>
        <section class="test-panel" aria-labelledby="category-title" :aria-busy="isLoading">
          <header class="list-header">
            <div><h2 id="category-title">{{ selectedCategoryTitle }}</h2><p>Testini seç ve öğrenmeye devam et.</p></div>
            <span v-if="!isLoading && !loadError" class="test-count">{{ tests.length }} test</span>
          </header>
          <div v-if="isLoading" class="list-state" role="status"><span class="spinner-border" aria-hidden="true"></span><p>Testler yükleniyor…</p></div>
          <div v-else-if="loadError" class="list-state" role="alert"><i class="bi bi-exclamation-circle" aria-hidden="true"></i><h3>Testler yüklenemedi</h3><p>Lütfen tekrar deneyin.</p><button type="button" class="test-button secondary-button" @click="GetCategory(selectedCategory)">Tekrar dene</button></div>
          <div v-else-if="!tests.length" class="list-state" role="status"><i class="bi bi-journal-text" aria-hidden="true"></i><h3>Henüz test bulunmuyor</h3><p>Pratik yapmak için başka bir kategori seçebilirsin.</p></div>
          <ul v-else class="test-list">
            <li v-for="test in tests" :key="test.id" class="test-row">
              <span class="test-icon" aria-hidden="true"><i class="bi bi-file-earmark-text"></i></span>
              <div class="test-info"><h3>{{ test.title }}</h3><p>{{ test.questions.length }} soru</p></div>
              <div class="test-actions">
                <button type="button" class="test-button secondary-button" :aria-label="test.title + ' sonuçları'" @click="OpenCloseExerciseResultModal(true, test.title, test.historyAnswers)"><i class="bi bi-bar-chart" aria-hidden="true"></i>Sonuçlar</button>
                <button type="button" class="test-button primary-button" :aria-label="test.title + ' testine başla'" @click="OpenCloseTestModal(true, test.title, test.questions, test.id)">Başla<i class="bi bi-arrow-right" aria-hidden="true"></i></button>
              </div>
            </li>
          </ul>
        </section>
      </div>
    </div>
  </main>
  <FooterInPage />
  <TestModal 
    :Title="this.selectedTest.title" 
    :ExcerciseData="this.selectedTest.questions" 
    :ExcerciseId="this.selectedTest.id"
    :Visible="testModalVisible"
    :IsLevelTest=IsLevelTest
    @CloseModal="OpenCloseTestModal($event,'',[],'')" 
    />

    <ExerciseResultModal 
      :Title="this.selectedTest.title" 
      :ExcerciseResultData="this.selectedTest.result"
      :Visible="exerciseResultModalVisible" 
      :IsLevelTest=IsLevelTest
      @CloseModal="OpenCloseExerciseResultModal($event,'',[])" 
      
    />
</template>

<script>
import { mapActions } from "vuex";
import NavBar from '@/components/Shared/NavBar.vue'
import FooterInPage from '@/components/Shared/FooterInPage.vue'
import { LoadingToast,UpdateToast,ToastType } from "@/common/notification.js";
import TestModal from '@/components/Modals/TestModal.vue'
import ExerciseResultModal from '@/components/Modals/ExerciseResultWithChartModal.vue'
export default {
  name: 'TestPage',
  data() {
    return {
      selectedCategory:0,
      selectedCategoryTitle:'',
      tests:[],
      isLoading:false,
      loadError:false,
      requestId:0,
      grammarList:[],
      grammarVisible:false,
      vocabularyList:[],
      vocabularyVisible:false,
      testModalVisible:false,
      exerciseResultModalVisible:false,
      selectedTest:{
        id:'',
        title:'',
        questions:[],
        result:[]
      }
    };
  },
  components: {
    NavBar,
    FooterInPage,
    TestModal,
    ExerciseResultModal
  },
  computed:{
    categoryGroups(){
      return [
        { id:'grammar-categories', title:'Grammar', icon:'bi bi-journal-text', items:this.grammarList, visible:this.grammarVisible },
        { id:'vocabulary-categories', title:'Vocabulary', icon:'bi bi-chat-square-text', items:this.vocabularyList, visible:this.vocabularyVisible }
      ];
    },
    IsLevelTest(){
      return this.selectedCategory===1;
    }
  },
  methods: {
    ...mapActions(["GetTests"]),
    async GetCategory(value){
      this.selectedCategory=value;
      if(value===1){
        this.selectedCategoryTitle = "Level Test";
      }else if(value>=11 && value<=14){
        let category = this.grammarList.find(x=>x.id==value);
        this.selectedCategoryTitle = 'Grammar / '+ category.label;
      }else if(value>=16 && value<=19){
        let category = this.vocabularyList.find(x=>x.id==value);
        this.selectedCategoryTitle = 'Vocabulary / '+ category.label;
      }

      const requestId = ++this.requestId;
      this.isLoading = true;
      this.loadError = false;
      this.tests = [];
      const toastId = LoadingToast();
      try {
        const res = await this.GetTests(value);
        if (requestId === this.requestId) this.tests = res;
        UpdateToast(toastId,res.description,ToastType().SUCCESS,100);
      } catch (err) {
        if (requestId === this.requestId) this.loadError = true;
        UpdateToast(toastId,err.message,ToastType().ERROR);
      } finally {
        if (requestId === this.requestId) this.isLoading = false;
      }
    },
    GrammarToggle(){
      if(this.grammarVisible){
        this.grammarVisible=false;
      }else{
        this.grammarVisible=true;
      }
    },
    VocabularyToggle(){
      if(this.vocabularyVisible){
        this.vocabularyVisible=false;
      }else{
        this.vocabularyVisible=true;
      }
    },
    OpenCloseTestModal(visible,title,questions,id){
     this.selectedTest.id=id;
     this.selectedTest.title=title;
     this.selectedTest.questions=questions;
     this.testModalVisible=visible;
    },
    OpenCloseExerciseResultModal(visible,title,result){
     this.selectedTest.title=title;
     this.selectedTest.result=result;
     this.exerciseResultModalVisible=visible;
    },
  },
  mounted: function() {
    this.grammarList =[
      {id:11,label:'Beginner'},
      {id:12,label:'Elementary'},
      {id:13,label:'Intermediate'},
      {id:14,label:'Advanced'},
    ];
    this.vocabularyList =[
      {id:16,label:'Beginner'},
      {id:17,label:'Elementary'},
      {id:18,label:'Intermediate'},
      {id:19,label:'Advanced'},
    ];
    this.GetCategory(1);  
  }
}
</script>
<style scoped>
.tests-page { background: #f7f9f7; color: #24382e; padding: 48px 0 64px; min-height: 70vh; }
.tests-container { max-width: 1120px; }
.page-header { margin-bottom: 32px; }
.back-link { display: inline-flex; align-items: center; gap: 8px; min-height: 44px; padding: 0 4px; margin-bottom: 16px; color: var(--brand-link); font-size: .85rem; font-weight: 600; text-decoration: none; }
.back-link:hover { color: #24382e; }
.back-link:focus-visible { outline: 3px solid var(--brand-link); outline-offset: 3px; }
.eyebrow { display: block; color: var(--brand-link); font-size: .72rem; font-weight: 700; letter-spacing: .12em; margin-bottom: 12px; }
.page-header h1 { font-size: clamp(2rem, 4vw, 2.6rem); font-weight: 700; letter-spacing: -.035em; margin-bottom: 12px; }
.page-header p { color: #637269; line-height: 1.7; margin: 0; }
.tests-layout { display: grid; grid-template-columns: 250px minmax(0, 1fr); gap: 24px; align-items: start; }
.category-panel, .test-panel { background: #fff; border: 1px solid #e4eae4; border-radius: 18px; }
.category-panel { padding: 22px 14px 16px; }
.category-panel h2 { font-size: .75rem; font-weight: 700; color: #637269; margin: 0 12px 16px; }
.category-button { display: flex; align-items: center; gap: 12px; width: 100%; border: 0; border-radius: 10px; padding: 13px 12px; background: transparent; color: #43594b; text-align: left; font-size: .9rem; font-weight: 600; }
.category-button > i:first-child { font-size: 1.1rem; }
.category-chevron { margin-left: auto; font-size: .7rem; }
.category-group { margin-top: 4px; }
.category-button:hover, .subcategory-list button:hover { background: #f4f7f3; }
.category-button.active, .subcategory-list button.active { background: #edf5eb; color: var(--brand-primary-hover); font-weight: 700; }
.category-button.group-selected { color: var(--brand-primary-hover); }
.subcategory-list { list-style: none; margin: 6px 0 12px 21px; padding: 0 0 0 14px; border-left: 1px solid #e4eae4; }
.subcategory-list button { width: 100%; text-align: left; background: transparent; border: 0; padding: 10px 12px; border-radius: 8px; font-size: .85rem; color: #637269; }
.category-note { margin: 20px 12px 0; padding-top: 18px; border-top: 1px solid #edf0ed; font-size: .78rem; line-height: 1.7; color: #637269; }
.test-panel { overflow: hidden; }
.list-header { display: flex; align-items: center; justify-content: space-between; gap: 16px; padding: 26px; border-bottom: 1px solid #edf0ed; }
.list-header h2 { font-size: 1.2rem; font-weight: 700; letter-spacing: -.02em; margin: 0 0 8px; overflow-wrap: anywhere; }
.list-header p { margin: 0; font-size: .85rem; color: #637269; }
.test-count { flex-shrink: 0; border-radius: 20px; padding: 6px 12px; background: #f1f5ef; color: var(--brand-link); font-size: .75rem; font-weight: 600; }
.test-list { list-style: none; padding: 0; margin: 0; }
.test-row { display: flex; align-items: center; gap: 16px; padding: 22px 26px; }
.test-row + .test-row { border-top: 1px solid #edf0ed; }
.test-row:hover { background: #fcfdfb; }
.test-icon { display: flex; align-items: center; justify-content: center; width: 44px; height: 48px; flex-shrink: 0; background: #f2f6ef; border-radius: 12px; color: var(--brand-link); font-size: 1.2rem; }
.test-info { flex: 1; min-width: 0; }
.test-info h3 { font-size: .95rem; font-weight: 600; line-height: 1.5; margin: 0 0 5px; overflow-wrap: anywhere; }
.test-info p { font-size: .78rem; color: #637269; margin: 0; }
.test-actions { display: flex; gap: 8px; flex-shrink: 0; }
.test-button { display: inline-flex; align-items: center; justify-content: center; gap: 8px; min-height: 42px; padding: 10px 14px; border: 1px solid transparent; border-radius: 9px; font-size: .82rem; font-weight: 600; }
.primary-button { background: var(--brand-link); color: #fff; }
.primary-button:hover { background: var(--brand-primary-hover); }
.secondary-button { background: #fff; border-color: #dce5dd; color: #43594b; }
.secondary-button:hover { background: #f2f6ef; border-color: #b7cbb8; }
.tests-page button:focus-visible { outline: 3px solid var(--brand-link); outline-offset: 3px; }
.list-state { padding: 60px 24px; text-align: center; color: #637269; }
.list-state > i { display: block; font-size: 2rem; color: var(--brand-link); margin-bottom: 16px; }
.list-state .spinner-border { color: var(--brand-link); margin-bottom: 16px; }
.list-state h3 { font-size: 1rem; font-weight: 600; color: #24382e; }
.list-state p { font-size: .88rem; line-height: 1.7; margin: 0; }
.list-state button { margin-top: 20px; }
@media (max-width: 991.98px) {
  .tests-layout { grid-template-columns: 220px minmax(0, 1fr); gap: 18px; }
  .test-row { flex-wrap: wrap; gap: 12px; }
  .test-actions { width: 100%; justify-content: flex-end; }
}
@media (max-width: 767.98px) {
  .tests-page { padding: 32px 0 40px; }
  .page-header { margin-bottom: 24px; }
  .tests-layout { grid-template-columns: minmax(0, 1fr); }
  .category-panel { padding: 18px 12px; }
  .category-note { display: none; }
  .list-header, .test-row { padding: 20px; }
  .test-actions { padding-left: 56px; }
  .test-actions .test-button { flex: 1; }
}
@media (max-width: 359.98px) {
  .list-header, .test-row { padding: 16px; }
  .test-actions { padding-left: 0; }
}
</style>
